import { Badge, type Tone } from '@/shared/ui/Badge';

import { EMAIL_STATUS_LABELS, type EmailStatus } from './types';

const TONES: Record<EmailStatus, Tone> = {
  pending: 'warn',
  processed: 'ok',
  error: 'danger',
};

/**
 * The state of an email, by exception. An email in `error` that the platform is asking
 * the provider for again on its own (`retrying`, contract v10.32) is not an error yet:
 * it says «Reintentando», in blue, in the list and in the detail alike.
 */
export function StatusBadge({
  status,
  retrying = false,
}: {
  status: EmailStatus;
  retrying?: boolean;
}) {
  if (status === 'error' && retrying) {
    return (
      <Badge tone="info" dot>
        Reintentando
      </Badge>
    );
  }
  return (
    <Badge tone={TONES[status]} dot>
      {EMAIL_STATUS_LABELS[status]}
    </Badge>
  );
}
